import React, {
    useState,
    Suspense,
    lazy
} from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {
    Avatar,
    Text,
    Button,
    Paper,
    ActionIcon,
    createStyles,
    Modal,
    Group,
    Menu,
    Stack
} from '@mantine/core';
import {
    IconHelp,
    IconBook,
    IconSettings,
    IconLogout,
} from '@tabler/icons';
import {
    testLogout,
    setUserAuthd
} from '../features/home/homeSlice';


const useStyles = createStyles((theme) => ({
    olayRow: {
        width: '100%',
        justifyContent: 'center'
        
    },
}));

export function AvatarOverlayCard() {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    //temporary to ensure we understand clicks then... set up the dispatch events
    function handleMenuClick(e) {
        console.log("menu area clicked");
        console.log(e.target.id);
        console.log(window.screen.width);
        console.log(window.screen.height);
        console.log("after width X height");
    }
    
    dispatch(setUserAuthd(false))
    const attemptLogout = async () => {
        let payload = {value: "information"};
        let fmtd_payload = JSON.stringify(payload)
        let c = await dispatch(testLogout(fmtd_payload))
        .unwrap()
        .then((res) => {
            //set prefix in the global state and add a selector to retrieve the data
            //window.location.href = 'http://192.168.1.74:3000/auth/login'
            window.location.href = 'https://app.ready.auction/auth/login';
        })
        .catch((rejected_logout) => {
            alert('logout was rejected')
        })
        .finally(() => {
            localStorage.setItem('loggedIn', 'false')
        })
        console.log(c.success);
    }
    
    //<div id="headerD" className={classes.headerArea} onClick={handleMenuClick}>
    return (
        <Stack spacing="lg">
            <ActionIcon className={classes.olayRow}>
                <IconHelp size={32}/>Help
            </ActionIcon>
            <ActionIcon className={classes.olayRow} onClick={attemptLogout}>
                <IconLogout size={32}/>Logout
            </ActionIcon>
        </Stack>
        

    );
}
